const found = {
  path: 'found',
  component: resolve => require(['../../../../../../pages/admin/reviewed/wechat/found'], resolve),
  meta: {isFound: true}
}

export default found
